import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  question: null,
};

export const questionSlice = createSlice({
  name: "question",
  initialState,
  reducers: {
    setQuestion: (state, action) => {
      state.question = action.payload;
    },
  },
});

export const { setQuestion } = questionSlice.actions;
export default questionSlice.reducer;
